// animate progress pie elements
(function( $ ) {
	let $progress = $('.js-progress');

	const callback = (entries) => {
		entries.forEach((entry) => {
			if ( entry.isIntersecting ) {
				entry.target.classList.add('anim-fill-pie');
			}
		});
	}
	const options = {
		threshold: 1.0
	};

	$progress.each((index, progress) => {
		const observer = new IntersectionObserver( callback, options );
		observer.observe(progress);
	});

	// Add scrolled class when window top scrolls past header.site-header
	const header = document.querySelector('.site-header');

	// Create a marker element before the header
	const marker = document.createElement('div');
	marker.style.position = 'absolute';
	marker.style.top = '0';
	marker.style.width = '100%';
	marker.style.height = '1px';
	document.body.prepend(marker);

	new IntersectionObserver(
		([entry]) => {
			header.classList.toggle('scrolled', !entry.isIntersecting);
		},
		{
			threshold: 0,
		}
	).observe(marker);

})( jQuery );